import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import * as LayoutActions from './layout.actions';

@Injectable()
export class LayoutEffects {
   constructor(private actions$: Actions) {}
}
